import type { ConceptDef } from '../types';

export const sightWordTap: ConceptDef = {
  kind: 'tileMatch',
  id: 'sight-word-tap',
  label: 'Sight Word Tap',
  category: 'Literacy',
  description: 'Hear a sight word; tap the matching word tile.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'the', answer: 'the' },
      { say: 'and', answer: 'and' },
      { say: 'is', answer: 'is' },
      { say: 'a', answer: 'a' },
      { say: 'I', answer: 'I' },
      { say: 'you', answer: 'you' },
      { say: 'see', answer: 'see' },
      { say: 'go', answer: 'go' },
    ],
  },
};
